import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Moment from "moment";
import { Dropdown } from "components/Dropdown/Dropdown";
import * as RFSActionType from "../constants";
import { CheckBoxSingle } from "../../components/checkboxes/check-box-single";
import * as ProjectActionType from "Projects/constants";
import * as RequestTypes from "Request-Types/constants";
import * as AuthActionType from "../../Auth/constants";
import Translate from "components/translate";

class AddRFS extends Component {
  static propTypes = {
    location: PropTypes.object,
    onSelectedLot: PropTypes.func,
    onSelectedStatus: PropTypes.func,
    history: PropTypes.object,
    dispatch: PropTypes.func,
    RFSStore: PropTypes.object,
    projectList: PropTypes.array,
    requestTypeList: PropTypes.array,
    userList: PropTypes.array,
    adminSelectList: PropTypes.array,
    lots: PropTypes.array,
    loading: PropTypes.any,
    UserProfile: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.queryParams = new URLSearchParams(this.props.location.search);
    this.state = {
      project: this.queryParams.get("isFromLot")
        ? {
            value: this.queryParams.get("projectId"),
            text: this.queryParams.get("projectName"),
            extensionValue: null,
            selected: false,
          }
        : null,
      lot: this.queryParams.get("isFromLot")
        ? {
            value: this.queryParams.get("lotId"),
            text:
              this.queryParams.get("lotNumber") +
              ", " +
              this.queryParams.get("streetAddress"),
            extensionValue: {
              coe: this.queryParams.get("coe"),
              lawsuit: "no",
              streetAddress: this.queryParams.get("streetAddress"),
            },
            selected: false,
          }
        : null,
      requestType: null,
      user: null,
      projectList: props.projectList,
      lots: props.lots,
      requestTypeList: props.requestTypeList,
      userList: props.userList,
      loading: false,
      isFetchingProject: false,
      isFetchingLot: false,
      isFetchingRequestType: false,
      isFetchingUser: false,
      check: false,
    };
  }

  componentDidMount() {
    // this.fetchRequestType()
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.projectList) {
      this.setState({ isFetchingProject: false });
    }
    if (nextProps.lots) {
      this.setState({ isFetchingLot: false });
    }
    if (nextProps.requestTypeList) {
      this.setState({ isFetchingRequestType: false });
    }
    if (nextProps.userList) {
      this.setState({ isFetchingUser: false });
    }
    // if (nextProps.loading.refNo && this.state.loading && nextProps.loading !== this.state.loading) {
    //   this.props.history.push(`/request-for-services/work-order/add/${nextProps.loading.refNo}`);
    // }
  }

  fetchProjectList = () => {
    this.setState({
      isFetchingProject: true,
    });
    this.props.dispatch({
      type: ProjectActionType.SELECT_LIST_PROJECT_ASYNC,
      params: {
        param: { searchKey: "", selectedValue: "" },
      },
      callback: () => {
        this.setState({ isFetchedProject: true });
      },
    });
  };

  fetchLots = () => {
    if (this.state.project) {
      this.setState({
        isFetchingLot: true,
      });
      this.props.dispatch({
        type: ProjectActionType.SELECT_LIST_LOT_ASYNC,
        params: {
          id: this.state.project.value,
          searchKey: "",
          selectedValue: "",
          setDefaultSelected: false,
        },
        callback: () => {
          this.setState({ isFetchedLot: true });
        },
      });
    }
  };

  fetchRequestType = () => {
    this.setState({
      isFetchingRequestType: true,
    });
    this.props.dispatch({
      type: RequestTypes.SELECT_LIST_ITEM_ASYNC,
      params: {
        searchKey: "",
        selectedValue: "",
        isBlueTape: false,
      },
      // callback: (data) => {
      //     if(data !== undefined){
      //       let array=data.find(k => k.customConfigOrderId);
      //       this.setState({
      //         requestType:array
      //       })
      //     }

      //      }
    });
  };

  fetchUser = () => {
    this.setState({
      isFetchingUser: true,
    });
    if (this.state.check) {
      this.props.dispatch({
        type: AuthActionType.SELECT_LIST_ADMIN_SUPER_ADMIN_ASYNC,
        params: {
          searchKey: "",
          selectedValue: "",
        },
      });
    } else {
      if (this.state.project) {
        this.props.dispatch({
          type: ProjectActionType.GET_LIST_USER_ASYNC,
          params: {
            projectId: this.state.project.value,
          },
        });
      }
    }
  };

  onCancel() {
    this.props.history.push("/request-for-services");
  }

  onSelectChange = (event, name) => {
    this.setState(
      {
        [name]: event.value,
      },
      () => {
        if (name === "project") {
          var user = this.state.project.extensionValue;
          // user['_$visited'] = true;
          this.setState({
            lot: null,
            user: user,
          });
        }
      }
    );
  };

  onChecked = () => {
    this.setState({
      check: !this.state.check,
      user: null,
    });
  };

  onSubmit = () => {
    const { project, lot, requestType, user } = this.state;
    if (!project || !lot || !requestType || !user) {
      return;
    }
    // this.setState({loading: true});
    this.props.dispatch({
      type: RFSActionType.ADD_RFS,
      payload: {
        projectId: project.value,
        lotId: lot.value,
        requestTypeId: requestType.value,
        managedByUserId: user.value,
      },
      callback: (data) => {
        this.props.history.push(
          `/request-for-services/work-order/add/${data.refNo}`
        );
      },
    });
  };
  getSelectOptions = (isFetched, currentOption, dataSource) => {
    let data = dataSource.find((k) => k.customConfigOrderId);
    console.log([{ ...data }]);
    // this.setState({requestType:data})
    // console.log('datasource', dataSource)
    // //  if (isFetched) {
    //   //  if (currentOption) {
    //      const optionFound = dataSource.find(item => item.value === currentOption.value);
    //      if (!optionFound) {
    //  console.log('getSelectOptions',[...dataSource, {...currentOption, except: true}])
    //  return [...dataSource, {...currentOption, except: true}];
    //      }
    //  console.log('getSelectOptions1',dataSource
    //  )
    //  return dataSource;
    //  }
    //  console.log('getSelectOptions2',dataSource)
    //  return dataSource;
    //  }
    //  console.log('getSelectOptions3',[{...currentOption}])
    //  return [{...currentOption}];
  };
  render() {
    const { project, lot, requestType, user, isFetchingRequestType } =
      this.state;

    const disable = !project || !lot || !requestType || !user;
    return (
      <div className="add-rfs">
        <div className="page-title clearfix">
          <h2 className="pull-left">Add new request</h2>
        </div>
        <ul className="breadcrumb">
          <li>
            <Link to={"/request-for-services"}>Requests for service</Link>
          </li>
          <li className="breadcrumb-siteone-li">Add new RFS</li>
        </ul>
        <div className="box-form-siteone">
          <div className="box-form-body">
            <p className="col-sm-12" style={{ opacity: 0.6 }}>
              Specify the <Translate translateKey="lot" /> that requires service
            </p>
            <div className="form-group">
              <label className="col-md-12">
                <Translate translateKey="project" capitalize />{" "}
                <span className="text-danger">*</span>
              </label>
              <div className="col-md-6">
                <Dropdown
                  filter={true}
                  onChange={(ref) => {
                    this.onSelectChange(ref, "project");
                  }}
                  className="filestring-dropdown filter-dropdown"
                  optionLabel="text"
                  placeholder="Please select"
                  style={{ width: "100%" }}
                  options={
                    this.state.isFetchedProject
                      ? this.props.projectList
                      : [{ ...this.state.project }]
                  }
                  loading={this.state.isFetchingProject}
                  name="projectList"
                  onRemote={this.fetchProjectList}
                  value={project}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-md-12">
                <Translate translateKey="lot" capitalize />{" "}
                <span className="text-danger">*</span>
              </label>
              <div className="col-md-6">
                <Dropdown
                  filter={true}
                  onChange={(ref) => {
                    this.onSelectChange(ref, "lot");
                  }}
                  className="filestring-dropdown filter-dropdown"
                  placeholder="Please select"
                  style={{ width: "100%" }}
                  options={
                    this.state.isFetchedLot
                      ? this.props.lots
                      : [{ ...this.state.lot }]
                  }
                  disabled={!this.state.project}
                  loading={this.state.isFetchingLot}
                  onRemote={this.fetchLots}
                  optionLabel="text"
                  value={lot}
                />
              </div>
              {lot && (
                <div
                  className="col-md-12"
                  style={{ marginTop: -10, marginBottom: 15 }}
                >
                  <span>Original COE: </span>
                  {lot.extensionValue.coe &&
                  lot.extensionValue.coe !== "null" ? (
                    <span>
                      {Moment(lot.extensionValue.coe).format("MM/DD/YYYY")}
                    </span>
                  ) : (
                    <span style={{ opacity: 0.5 }}>(Not specified)</span>
                  )}
                </div>
              )}
            </div>
            <div className="form-group">
              <label className="col-md-12">
                Request type <span className="text-danger">*</span>
              </label>
              <div className="col-md-6">
                <Dropdown
                  filter={true}
                  onChange={(ref) => {
                    this.onSelectChange(ref, "requestType");
                  }}
                  className="filestring-dropdown filter-dropdown"
                  placeholder="Please select"
                  options={this.props.requestTypeList}
                  loading={this.state.isFetchingRequestType}
                  style={{ width: "100%" }}
                  optionLabel="text"
                  onRemote={this.fetchRequestType}
                  value={requestType}
                  showClear={true}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-md-12">
                RFS managed by <span className="text-danger">*</span>
              </label>
              <div className="col-md-6">
                {this.props.UserProfile.sso ? (
                  <Dropdown
                    filter={true}
                    onChange={(ref) => {
                      this.onSelectChange(ref, "user");
                    }}
                    className="filestring-dropdown filter-dropdown"
                    placeholder="Please select"
                    onRemote={this.fetchUser}
                    options={
                      this.state.check
                        ? this.props.adminSelectList
                        : this.props.userList
                    }
                    loading={this.state.isFetchingUser}
                    disabled={!this.state.project && !this.state.check}
                    value={user}
                    optionLabel="text"
                    location="rfs manage"
                    groupLabels={[
                      {
                        label: "System users",
                        field: "sso",
                        condition: [true],
                      },
                      {
                        label: "Builder users",
                        field: "sso",
                        condition: [false, null],
                      },
                    ]}
                    style={{ width: "100%", marginBottom: 0 }}
                  />
                ) : (
                  <Dropdown
                    filter={true}
                    onChange={(ref) => {
                      this.onSelectChange(ref, "user");
                    }}
                    className="filestring-dropdown filter-dropdown"
                    placeholder="Please select"
                    onRemote={this.fetchUser}
                    options={
                      this.state.check
                        ? this.props.adminSelectList
                        : this.props.userList
                    }
                    loading={this.state.isFetchingUser}
                    disabled={!this.state.project && !this.state.check}
                    value={user}
                    optionLabel="text"
                    style={{ width: "100%", marginBottom: 0 }}
                  />
                )}

                <CheckBoxSingle
                  style={{ marginTop: 0, marginBottom: 20 }}
                  checked={this.state.check}
                  ref={(c) => {
                    this.check = c;
                  }}
                  name="checkAdmin"
                  label="I want to assign this request to admin"
                  className="checkbox-default noteTitle"
                  onChecked={this.onChecked}
                />
              </div>
            </div>
            <div className="form-group">
              <div className="col-sm-12">
                <button
                  className="btn btn-primary btn-siteone-default btn-wo-edit"
                  style={{ marginRight: 15 }}
                  onClick={() => {
                    this.props.history.push("/request-for-services");
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-siteone"
                  disabled={disable}
                  onClick={this.onSubmit}
                >
                  Proceed to request for service
                </button>
              </div>
            </div>
            <div className="clearfix" />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    projectList: state.ProjectStore.ProjectList,
    lots: state.ProjectStore.LotList,
    requestTypeList: state.RequestTypeStore.ItemList,
    userList: state.ProjectStore.UserSelectList,
    adminSelectList: state.authReducer.adminSelectList,
    loading: state.RFSStore.Loading,
    UserProfile: state.UserStore.UserProfile,
  };
};

export default connect(mapStateToProps)(AddRFS);



// WEBPACK FOOTER //
// ./src/Request-Services/Containers/add-rfs.js